import {
  getLeoUuid,
  LeoUUID,
  getList,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { SurveyRule, SurveyRuleDTO } from "./surveyRule";
/* eslint-disable import/export */
export abstract class GetSurveyRulesRPC implements
  LeoRPC<GetSurveyRulesRPC.Request, GetSurveyRulesRPC.Response, GetSurveyRulesRPC.Errors.Errors>
{
  abstract execute(
    request: GetSurveyRulesRPC.Request
  ): Promise<LeoRPCResult<GetSurveyRulesRPC.Response, GetSurveyRulesRPC.Errors.Errors>>;
}

export namespace GetSurveyRulesRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    surveyId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetSurveyRulesRPCRequest: boolean = true;
  
    readonly surveyId: LeoUUID;
  
  
    constructor(
    surveyId: LeoUUID
    ) {
      this.surveyId = surveyId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const surveyId = getLeoUuid(dto, "surveyId", InvalidRequestSurveyIdError);
      return new Request(
        surveyId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          surveyId: this.surveyId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetSurveyRulesRPC(surveyId='${this.surveyId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    surveyRules: SurveyRuleDTO[];
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetSurveyRulesResponse: boolean = true;
  
    readonly surveyRules: SurveyRule[];
  
  
    constructor(
    surveyRules: SurveyRule[]
    ) {
      this.surveyRules = surveyRules;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const surveyRules = getList<SurveyRuleDTO, SurveyRule>(
        dto,
        "surveyRules",
        SurveyRule.fromDTO,
        InvalidResponseSurveyRulesError
      );
      return new Response(
        surveyRules
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          surveyRules: this.surveyRules.map((e: SurveyRule) => { return e.toDTO() })
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetSurveyRules(surveyRules='${this.surveyRules}')`;
  };
  

  export enum RPCError {
    InvalidSurveyId = "INVALID_SURVEY_ID"
  }

  export namespace Errors {
    
    export interface InvalidSurveyIdDTO {
      code: string;
    }
    
    export class InvalidSurveyId extends LeoRPCError<RPCError> {
      readonly isInvalidSurveyId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidSurveyId;
        super(code);
      }
    
    
      toDTO(): InvalidSurveyIdDTO {
        const dto: InvalidSurveyIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidSurveyId.prototype.toString = function toString(): string {
      return `GetSurveyRulesRPC.INVALID_SURVEY_ID()`;
    };
    

    export type Errors = InvalidSurveyId;
    export type ErrorsDTO = InvalidSurveyIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidSurveyId:
          return new InvalidSurveyId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestSurveyIdError extends GetSurveyRulesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestSurveyIdError";
  }
}

export class InvalidResponseSurveyRulesError extends GetSurveyRulesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseSurveyRulesError";
  }
}

export class InvalidResponseInvalidSurveyIdError extends GetSurveyRulesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidSurveyIdError";
  }
}

